import { useEffect, useState } from "react"
import {postBanner, patchBanner,getBannerById } from "../../services/BannersService"
import { BannersFormContext } from "./BannersContext"
import { useNavigate, useParams } from 'react-router-dom';
//import { Banners } from '../../routes/RoutesConstants'

export const BannersFormState = ({ children }) => {
    const [report, setReport] = useState({})
    const navigate = useNavigate();
    const { id } = useParams()
 
    useEffect(() => {
        if (id) getBannerByIdData(id)
    }, [])

    const getBannerByIdData = async (id) => {
        let res = await getBannerById(id)
        if (res) setReport(res)
    }

    const postBannerData = async (body) => {
        const res = await postBanner(body)
        if (res) navigate("/banners");
    }

    const patchBannerData = async (id, body) => {
        const res = await patchBanner(id, body)
        if (res) navigate("/banners");
    }


    return <BannersFormContext.Provider value={{
        report,
        postBannerData,
        patchBannerData,
        getBannerByIdData
    }} >
        {children}
    </BannersFormContext.Provider>
}